export const EmojiAngryDim = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <g clip-path="url(#clip0_5328_192153)">
      <path
        fill="#171A1C"
        d="m19.622 21.532-3.17 4.78-3.908-21.654 5.72 11.736 4.756-7.171 1.114 5.504 2.064 18.05-6.576-11.245Z"
        opacity=".1"
      />
      <g filter="url(#filter0_f_5328_192153)" opacity=".5">
        <path
          fill="#1A83FF"
          d="m19.96 21.311-4.063 6.126L10.89-.308l7.33 15.037 6.093-9.189 1.428 7.054 2.644 23.124-8.426-14.407Z"
        />
      </g>
      <g filter="url(#filter1_f_5328_192153)">
        <ellipse
          cx="32.003"
          cy="61.074"
          fill="#F6F7F8"
          rx="23.515"
          ry="1.011"
        />
      </g>
      <mask
        id="mask0_5328_192153"
        width="42"
        height="42"
        x="11"
        y="9"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <circle cx="31.969" cy="29.924" r="20.924" fill="#1A83FF" />
      </mask>
      <g mask="url(#mask0_5328_192153)">
        <circle cx="31.969" cy="29.924" r="20.924" fill="#85C0FC" />
        <circle
          cx="31.969"
          cy="29.924"
          r="20.924"
          fill="url(#paint0_radial_5328_192153)"
        />
        <circle
          cx="31.969"
          cy="29.924"
          r="20.924"
          fill="url(#paint1_linear_5328_192153)"
        />
        <g filter="url(#filter2_f_5328_192153)" opacity=".5">
          <path
            fill="url(#paint2_linear_5328_192153)"
            d="M13.729 42.472h-3.29l9.11-8.73-3.796 6.453h4.935l-2.278 2.277-7.97 6.706 3.289-6.706Z"
          />
        </g>
        <g filter="url(#filter3_f_5328_192153)" opacity=".5">
          <path
            fill="url(#paint3_linear_5328_192153)"
            d="M43.682 45.32c5.77-4.442 7.015-8.864 7.89-15.05-1.854 7.309-5.171 10.678-9.935 14.099-5.49 3.943-10.252 4.5-18.309 3.733 7.062 1.826 14.274 1.897 20.354-2.782Z"
          />
        </g>
      </g>
      <g filter="url(#filter4_d_5328_192153)">
        <ellipse
          cx="41.981"
          cy="23.436"
          fill="url(#paint4_radial_5328_192153)"
          rx="7.804"
          ry="8.266"
          transform="rotate(20 41.981 23.436)"
        />
      </g>
      <ellipse
        cx="46.52"
        cy="27.896"
        fill="#fff"
        rx=".754"
        ry="1.914"
        transform="rotate(44.325 46.52 27.896)"
      />
      <ellipse
        cx="42.984"
        cy="30.117"
        fill="#fff"
        rx=".406"
        ry="1.031"
        transform="rotate(77.674 42.984 30.117)"
      />
      <g filter="url(#filter5_d_5328_192153)">
        <ellipse
          cx="21.663"
          cy="23.442"
          fill="url(#paint5_radial_5328_192153)"
          rx="7.804"
          ry="8.266"
          transform="rotate(-20 21.663 23.442)"
        />
      </g>
      <circle cx="24.002" cy="26" r="2" fill="#0052B3" opacity=".6" />
      <circle cx="39.502" cy="26" r="2" fill="#0052B3" opacity=".6" />
      <ellipse
        cx="28.002"
        cy="23.934"
        fill="#fff"
        rx=".754"
        ry="1.914"
        transform="rotate(4.326 28.002 23.934)"
      />
      <ellipse
        cx="26.725"
        cy="27.916"
        fill="#fff"
        rx=".406"
        ry="1.031"
        transform="rotate(37.674 26.725 27.916)"
      />
      <circle
        cx="32"
        cy="41"
        r="4"
        stroke="#0052B3"
        stroke-linecap="round"
        stroke-width="2.242"
        opacity=".6"
      />
      <path
        stroke="#0052B3"
        stroke-linecap="round"
        stroke-width="2.242"
        d="m20.006 12.497 10 7.505M43.74 13.448l-9.685 6.365"
        opacity=".6"
      />
      <path
        fill="#171A1C"
        d="m50.102 52.959-.925 1.395-1.14-6.32 1.669 3.426 1.388-2.093.325 1.606.602 5.267-1.919-3.281Z"
        opacity=".1"
      />
      <g filter="url(#filter6_f_5328_192153)" opacity=".5">
        <path
          fill="#1A83FF"
          d="m50.196 53.334-.925 1.395-1.14-6.32 1.669 3.426 1.388-2.093.325 1.606.602 5.267-1.919-3.281Z"
        />
      </g>
      <g filter="url(#filter7_f_5328_192153)" opacity=".5">
        <path
          fill="#1A83FF"
          d="M10.939 43.722H7.605l9.232-8.847-3.846 6.54h5l-2.308 2.307-8.078 6.795 3.334-6.795Z"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_5328_192153"
        width="21.786"
        height="40.315"
        x="8.745"
        y="-2.451"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192153"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter1_f_5328_192153"
        width="50.463"
        height="5.457"
        x="6.772"
        y="58.346"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192153"
          stdDeviation=".858"
        />
      </filter>
      <filter
        id="filter2_f_5328_192153"
        width="14.54"
        height="19.729"
        x="8.294"
        y="31.596"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192153"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter3_f_5328_192153"
        width="32.536"
        height="23.276"
        x="21.182"
        y="28.128"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192153"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter4_d_5328_192153"
        width="29.244"
        height="29.949"
        x="28.862"
        y="10.712"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192153"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192153"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_5328_192153"
        width="29.244"
        height="29.949"
        x="8.543"
        y="10.72"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192153"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192153"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_f_5328_192153"
        width="8.276"
        height="12.503"
        x="45.985"
        y="46.26"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192153"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter7_f_5328_192153"
        width="14.677"
        height="19.933"
        x="5.46"
        y="32.729"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192153"
          stdDeviation="1.073"
        />
      </filter>
      <radialGradient
        id="paint0_radial_5328_192153"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(22.56203 21.52868 -20.13218 21.0985 24.9 24.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D6FF" />
        <stop offset=".418" stop-color="#80BAFF" />
        <stop offset=".736" stop-color="#1A83FF" />
        <stop offset="1" stop-color="#006AE6" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_5328_192153"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -3.958 57.15) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_5328_192153"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -14.123 34.024) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_5328_192153"
        x1="22.02"
        x2="34.953"
        y1="11.078"
        y2="29.377"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#B3D6FF" />
        <stop offset=".353" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5328_192153"
        x1="17.634"
        x2="13.25"
        y1="46.196"
        y2="44.251"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A83FF" />
        <stop offset="1" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5328_192153"
        x1="43.408"
        x2="36.15"
        y1="45.394"
        y2="38.237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A83FF" />
        <stop offset="1" stop-color="#E6F1FF" />
      </linearGradient>
      <clipPath id="clip0_5328_192153">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);
